import React from 'react';
import Image from '../assets/about.png';
import {FaGithub, FaLinkedin} from 'react-icons/fa';
import {TypeAnimation} from 'react-type-animation';
import {motion} from 'framer-motion';
import { Icon } from '@iconify/react';
import {fadeIn} from '../variants';



const Banner = () => {
  return <section className="min-h-[85vh] lg:min-h-[78vh] flex item-center" >
    <div className="container mx-auto mt-10px ">
      <div className="flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gapx12">
        <div className="flex-1 text-center font-secondary lg:text-left">
          <motion.h1
           variants={fadeIn('up',0.3)} initial="hidden" whileInView={'show'} viewport={{once:false,amount:0.7}} className="text-[55px] font-bold loading-[0.8] lg:text-[110px]">ARUNKUMAR</motion.h1>
        <motion.div 
        variants={fadeIn('up',0.5)} initial="hidden" whileInView={'show'} viewport={{once:false,amount:0.7}} 
        className='mb-10 mt-10 text-[36px] lg:text-[60px] font-secondary font-semibold uppercase loading-[1]'>
            <span className='text-white mr-4'> I am </span>
          <TypeAnimation sequence={[
            'a Student',2000,'a Full Stack Developer',2000,'an Aspiring SDE',2000,
          ]}
            speed={50}
            className='text-fuchsia-600 md:font-bold'
            wrapper='span'
            repeat={Infinity}
          />
        </motion.div>
        <div>
          <motion.p
            variants={fadeIn('up',0.6)} initial="hidden" whileInView={'show'} viewport={{once:false,amount:0.7}}
            className="mb-8 max-w-lg mx-auto lg:mx-0">
This is Arunkumar, a self-driven and motivated learner who adept in Software technologies and developing products. I am proficient in grasping new technical concepts and utilizing them in an efficient way. I aspire to become an SDE and also interested in Data Analysis</motion.p>
          
          <motion.div 
            variants={fadeIn('up',0.7)} initial="hidden" whileInView={'show'} viewport={{once:false,amount:0.7}}
            className="flex max-w-max gap-x-6 items-center mb-12 mx-auto lg:mx-0">
            <button className="btn btn-lg" onClick={() => {
    window.location.href = 'mailto:a.arunsivaofficial@gmail.com';}}>Contact me</button>
            <a href='https://drive.google.com/file/d/1EfwBU7jiMbfSZVW1-3E_cf3yTD0n6Zv5/view?usp=sharing' className='text-gradient btn-link' download target='_blank'>My Portfolio</a>
          </motion.div>

          <motion.div 
            variants={fadeIn('up',0.8)} initial="hidden" whileInView={'show'} viewport={{once:false,amount:0.7}}
            className="flex text-[30px] gap-x-6 max-w-max mx-auto lg:mx-0">
            <a href="https://www.linkedin.com/in/ArunkumarA03"><FaLinkedin/></a>
            <a href="https://github.com/Arunsiva003"><FaGithub/></a>
            <a href="https://leetcode.com/ArunSiva/"><Icon icon="simple-icons:leetcode" /></a>
            <a href="https://www.codechef.com/users/stellar003"><Icon icon="simple-icons:codechef" /></a>
          </motion.div>

        </div>
        </div> 
        <motion.div
          variants={fadeIn('up',0.5)} initial="hidden" whileInView={'show'} viewport={{once:false,amount:0.7}}
          className="hidden lg:flex flex-1 lg:max-w-[402px]" >
          <img src={Image} alt="" width="320px" height="320px" className="border-l-4 border-b-4 border-fuchsia-500"/>
        </motion.div>  
      </div>  
    </div>
  </section>;
};

export default Banner;
